export default "__VITE_ASSET__351f3954__"